export const RequestProfileWidgetKey = {
  ADDRESS: 'address',
  AI_SUMMARY: 'ai-summary',
  ASSIGNEES: 'assignees',
  BUDGET_PLAN: 'budget-plan',
  BUILDING_GROUPS: 'building-groups',
  CREATED: 'updated',
  FINISHED: 'finished',
  INHABITANTS: 'inhabitants',
  LABELS: 'labels',
  PROVIDERS: 'providers',
  SIDE_WORKERS: 'side-workers',
  TIME_TRACKING: 'completion-time',
}
